// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rhO3","fullView":"styles_fullView__1A7X5"};